import React, { useState, useEffect, useRef } from "react";

import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";

import "./InlineEdit.less";

const InlineEdit = (props) => {
  // console.log("InlineEdit:", props);
  const wrapperRef = useRef(null);
  const textRef = useRef(null);
  const inputRef = useRef(null);
  const [isInputActive, setIsInputActive] = useState(false);
  const [inputPrevious, setInputPrevious] = useState(props.text);
  const [inputValue, setInputValue] = useState(props.text);

  // focus the cursor in the input field on edit start
  useEffect(() => {
    if (isInputActive) {
      inputRef.current.focus();
    }
  }, [isInputActive]);

  const onSave = (e) => {
    e.stopPropagation();
    setIsInputActive(false);
    setInputPrevious(inputRef.current.value);
    setInputValue(inputRef.current.value);
    props.onSave(inputRef.current.value);
  };

  const onCancel = (e) => {
    e.stopPropagation();
    setIsInputActive(false);
    setInputValue(inputPrevious);
  };

  function createMarkup(text) {
    let htmlText = text.replace(/(?:\r\n|\r|\n)/g, "<br>");
    return { __html: htmlText };
  }

  // test <img src="http://dreamchimney.com/tracks/track_images/41271.jpg" />
  return (
    <span className="inline-text" ref={wrapperRef}>
      <span ref={textRef} className={`inline-text_copy inline-text_copy--${!isInputActive ? "active" : "hidden"}`}>
        <span dangerouslySetInnerHTML={createMarkup(inputValue)} />

        <span className="inline-edit-icon">
          {(props.loading && <FontAwesomeIcon icon={faSpinner} spin />) || (
            <span onClick={() => setIsInputActive(true)}>
              <FontAwesomeIcon icon={["fas", "edit"]} />
            </span>
          )}
        </span>
      </span>
      <textarea
        ref={inputRef}
        onChange={(e) => {
          setInputValue(e.target.value);
        }}
        value={inputValue}
        className={`inline-text_input inline-text_input--${isInputActive ? "active" : "hidden"}`}
      />

      <div className={`inline-buttons inline-text_input--${isInputActive ? "active" : "hidden"}`}>
        {/* <input type="button" value="save"  disabled={props.loading} /> */}
        <Button disabled={props.loading} variant="success" onClick={onSave} type="button">
          Save
        </Button>
        <Button disabled={props.loading} variant="light" onClick={onCancel} type="button" style={{ marginLeft: "20px" }}>
          Cancel
        </Button>
        {/* <input type="button" value="cancel" onClick={onCancel} disabled={props.loading} /> */}
      </div>
    </span>
  );
};

InlineEdit.propTypes = {
  text: PropTypes.string,
};

export default InlineEdit;
